export function buildGrantUrl(path: string, scopes?: string[]) {
  const url = new URL(path, window.location.origin);

  for (const scope of (scopes || [])) {
    url.searchParams.append('scopes[]', scope);
  }

  return url;
}
